interface ListeCspJson {
    cspCode: string;
    cspLib: string;
}

export class ListeCsp {
    cspCode: string;
    cspLib: string;

    constructor(input: ListeCspJson) {
        this.cspCode = input.cspCode;
        this.cspLib = input.cspLib;
     }
}



// WEBPACK FOOTER //
// ./src/app/shared/models/liste-csp.model.ts